//@flow

import React from "react";
import { Grid } from "semantic-ui-react";

import FormLabelWithDivider from "Commons/Components/FormComponents/components/FormLabelWithDivider";

export const FormLabelWithoutDivider = ({
  title,
  themed,
  subTitle,
  largeIcons,
  inline,
}: {
  title: string,
  themed?: boolean,
  subTitle?: string,
  largeIcons?: boolean,
  inline?: boolean,
}) => (
  <FormLabelWithDivider
    desktop
    leftAlign
    centered
    divider={false}
    width={16}
    title={title}
    themed={themed}
    subTitle={subTitle}
    largeIcons={largeIcons}
    inline={inline}
  />
);

export const FormLabelAbove = ({
  title,
  width = 16,
  id,
  tooltip,
}: {
  title: string,
  width?: number,
  id?: string,
  tooltip?: string,
}) => (
  <Grid.Row>
    <FormLabelWithDivider
      id={id}
      leftAlign
      divider={false}
      width={width}
      title={title}
      tooltip={tooltip}
      secondary
      above
    />
  </Grid.Row>
);
